import { makeStyles } from "@mui/styles";
export const useStyles = makeStyles(({ spacing }) => ({
    icon_button: {
        opacity: 0.5,
    },
    icon_button__active: {
        opacity: 1,
    },
    ui_text_field: {
        marginBottom: ({ gutterBottom }) => (gutterBottom ? spacing(2) : 0),
    },
}));
//# sourceMappingURL=ui_text_field.css.js.map